import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { FormsService } from '../../../shared/forms.service';
import { HttpService } from '../../../shared/http.service';
import { AlertService } from '../../../shared/alert.service';
import { TransactionResponse } from '@builtbybros/al-model';
import moment = require('moment');

@Component({
  selector: 'app-transaction-form',
  templateUrl: './transaction-form.component.html',
  styleUrls: ['./transaction-form.component.scss']
})
export class TransactionFormComponent implements OnInit {

  transactionForm: FormGroup;
  transactionId: number;
  url = '/Transaction/';
  transactionData: TransactionResponse.Transaction;
  transactionsReady = false;
  delivered = false;
  deliveryInfo = false;
  billingInfo = false;
  mpStatus: any;
  mpStatusReady = false;
  mpStatusError = false;
  paymentStatus = {
    'pending': 'Pendiente',
    'approved': 'Aprobado',
    'authorized': 'Autorizado',
    'in_process': 'En Proceso',
    'in_mediation': 'En disputa',
    'rejected': 'Rechazado',
    'cancelled': 'Cancelado',
    'refunded': 'Devuelto',
    'charged_back': 'Charged Back'
  };
  msg = {
    'loadError': 'Hubo un error al cargar la orden de compra',
    'updateSuccess': 'Cambio de status de entrega correcto',
    'updateError': 'Hubo un error al cambiar el status de entrega'
  };


  constructor(private route: ActivatedRoute,
              private fb: FormBuilder,
              private formsService: FormsService,
              private httpService: HttpService,
              private alertService: AlertService) {
    this.createForm();
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['transactionId']) {
        this.transactionId = +params['transactionId'];
        this.getMpPaymentStatus();
        const responseExpected = new TransactionResponse.Transaction();
        this.httpService.get(this.url, this.transactionId, responseExpected)
          .subscribe(
            transactionResponse => {
              this.transactionData = transactionResponse;
              this.transactionForm.patchValue({'createdAt': moment(transactionResponse['createdAt']).format('DD/MM/YYYY HH:mm')});
              this.transactionForm.patchValue({'paymentId':
                this.transactionData.pay ? this.transactionData.pay.externalId : 'No hay pago registrado'});
              this.transactionForm.patchValue({'name':
                `${transactionResponse['customerName']} ${transactionResponse['customerLastName']}`});
              this.transactionForm.patchValue({'email': transactionResponse['customerEmail']});
              this.transactionForm.patchValue({'phone': transactionResponse['customerPhone']});
              if (transactionResponse['shippingAddress'] || transactionResponse['shippingApt'] || transactionResponse['shippingCity'] || transactionResponse['shippingDepartament'] || transactionResponse['shippingNumber'] || transactionResponse['shippingZip']) {
                this.deliveryInfo = true;
                this.transactionForm.patchValue({'shippingDepartament': transactionResponse['shippingDepartament']});
                this.transactionForm.patchValue({'shippingCity': transactionResponse['shippingCity']});
                this.transactionForm.patchValue({'shippingZip': transactionResponse['shippingZip']});
                this.transactionForm.patchValue({'shippingAddress': transactionResponse['shippingAddress']});
                this.transactionForm.patchValue({'shippingNumber': transactionResponse['shippingNumber']});
                this.transactionForm.patchValue({'shippingApt': transactionResponse['shippingApt']});
              }
              if (transactionResponse['billingAddress'] || transactionResponse['billingRut'] || transactionResponse['billingSocial']) {
                this.billingInfo = true;
                this.transactionForm.patchValue({'billingAddress': transactionResponse['billingAddress']});
                this.transactionForm.patchValue({'billingRut': transactionResponse['billingRut']});
                this.transactionForm.patchValue({'billingSocial': transactionResponse['billingSocial']});
              }
              this.delivered = transactionResponse['delivered'] ? true : false;
              this.transactionsReady = true;
            },
            error => {
              this.alertService.error(this.msg['loadError']);
            }
          );
      }
    });
  }

  /**
   * Consulta el estado del pago directamente a MercadoPago (via la API),
   * sin depender de los registros locales de la base de datos.
   */
  getMpPaymentStatus() {
    this.mpStatusReady = false;
    this.mpStatusError = false;
    this.httpService.getRaw(this.url + this.transactionId + '/PaymentStatus', [])
      .subscribe(
        mpStatusResponse => {
          this.mpStatus = mpStatusResponse;
          if (this.mpStatus && this.mpStatus['dateApproved']) {
            this.mpStatus['dateApprovedFormatted'] = moment(this.mpStatus['dateApproved']).format('DD/MM/YYYY HH:mm');
          }
          if (this.mpStatus && this.mpStatus['paymentId']) {
            this.transactionForm.patchValue({'paymentId': this.mpStatus['paymentId']});
          }
          this.mpStatusReady = true;
        },
        error => {
          this.mpStatusError = true;
        }
      );
  }

  statusLabel(status) {
    return status && this.paymentStatus[status] ? this.paymentStatus[status] : status;
  }

  setStatus(value) {
    this.delivered = value;
    this.httpService.patch(this.transactionId, this.url, {'delivered': this.delivered})
      .subscribe(
        deliveryResponse => {
          this.alertService.success(this.msg['updateSuccess']);
        },
        error => {
          this.alertService.error(this.msg['updateError']);
        }
      );

  }

  createForm() {
    this.transactionForm = this.fb.group({
      'paymentId': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'createdAt': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'name': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'email': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'shippingDepartament': [
        null,
        null
      ],
      'shippingCity': [
        null,
        null
      ],
      'shippingZip': [
        null,
        null
      ],
      'shippingAddress': [
        null,
        null
      ],
      'shippingNumber': [
        null,
        null
      ],
      'shippingApt': [
        null,
        null
      ],
      'billingAddress': [
        null,
        null
      ],
      'billingRut': [
        null,
        null
      ],
      'billingSocial': [
        null,
        null
      ],
      'phone': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'status': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/transaction/shared/transaction-form/transaction-form.component.ts